import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

type IconChevronUpProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
}

export const IconChevronUp = ({ ...props }: IconChevronUpProps) => (
  <MySvgIcon
    width="21px"
    height="21px"
    viewBox="0 0 512 512"
    version="1.1"
    title="Up"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
    </g>
  </MySvgIcon>
)
